import axios from 'axios';
import imagesLoaded from 'imagesloaded';
import * as Utils from './utils';

export function init() {
    const timeline = document.querySelector('.js-timeline'),
        list = timeline.querySelector('.js-timeline-list'),
        btn = timeline.querySelector('.js-timeline-load-more'),
        limit = 8;

    // When clicking load more button
    btn.addEventListener('click', e => {
        e.preventDefault();

        // Count number of items already in list
        let itemCount = list.querySelectorAll('li').length;

        // Show loading icon
        btn.classList.add('loading');

        // Run request for more items 
        axios
            .get(`/timeline/get-items?offset=${itemCount}&limit=${limit}`, {
                headers: { "X-Requested-With": "XMLHttpRequest" }
            })
            .then(function(response) {
                // Append items to list
                let newItemsHTML = Utils.stringToHTML(response.data);
                
                // Loop over returned list items and insert to DOM
                newItemsHTML.querySelectorAll('li').forEach(item => {
                    list.appendChild(item);
                })
                
                // Once images have been loaded
                imagesLoaded(list, () => {
                    // Run 'watch' transition functions
                    Utils.animateInViewEls('.js-watch', 'in-view', 0.1);

                    // Hide loading icon
                    btn.classList.remove('loading');

                    // Check if we need the loading button still?
                    if (list.querySelectorAll('li').length >= parseInt(timeline.dataset.total)) {
                        timeline.classList.add('timeline--complete');
                    }
                });
            })
            .catch(function(error) {
                console.error(error);
            });
    })
}